// todo:ai-review
/**
 * Utility functions for book processing
 */
/**
 * Convert a path segment or filename to a human-readable title.
 * - Removes numeric prefixes (e.g., "01-chapter" → "Chapter")
 * - Replaces dashes and underscores with spaces
 * - Title-cases each word
 */
export function formatTitle(str) {
    if (!str)
        return "Untitled";
    const withoutPrefix = str.replace(/^\d+[-_\s]*/, "");
    return (withoutPrefix
        .replace(/[-_]/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim() || str);
}
//# sourceMappingURL=index.js.map